import gql from 'graphql-tag';

const checkResourcePasswordQuery = gql`
  query CheckResourcePasswordSettings($resourceId: String!, $password: String!) {
    checkResourcePassword(resourceId: $resourceId, password: $password)
  }
`;

const checkResourcePassword = (resourceId) => ({
  query: checkResourcePasswordQuery,
  module: 'users',
  buildVariables: (password) => ({ resourceId, password })
});

export default checkResourcePassword;